import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Box, IconButton, Tooltip } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import SettingsIcon from '@mui/icons-material/Settings';
import BaseCard from './BaseCard';
import ProjectSettingsModal from '../ProjectSettingsModal';

const ProjectNameCard = ({
  projectName,
  projectData,
  customerLogoUrl,
  dashboardSettings,
  t,
  user,
  onUpdateSettings,
  updateDashboardProjectName,
  notify,
  units,
}) => {
  const [settingsOpen, setSettingsOpen] = useState(false);

  const handleSettingsClick = (e) => {
    e.stopPropagation();
    setSettingsOpen(true);
  };

  const handleSettingsClose = () => {
    setSettingsOpen(false);
  };

  const handleSettingsSave = (newSettings) => {
    if (onUpdateSettings) {
      onUpdateSettings(newSettings);
    }
  };

  return (
    <>
      <Box position='relative'>
        <BaseCard
          title={projectName || t('no_project_selected')}
          icon={<BusinessIcon />}
          className='compact-card project-name-card'
        >
          <Box
            display='flex'
            alignItems='center'
            justifyContent='center'
            height='100%'
          >
            {/* Logo */}
            {customerLogoUrl && (
              <Box
                component='img'
                src={customerLogoUrl}
                alt='Customer Logo'
                sx={{
                  maxWidth: '120px',
                  maxHeight: '80px',
                  objectFit: 'contain',
                }}
              />
            )}
          </Box>
        </BaseCard>

        {user?.isAQS && (
          <Tooltip title={t('project_settings')}>
            <IconButton
              onClick={handleSettingsClick}
              size='small'
              sx={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                backgroundColor: 'white',
                border: '1px solid #e8e8e8',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                padding: '4px',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              <SettingsIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <ProjectSettingsModal
        open={settingsOpen}
        onClose={handleSettingsClose}
        projectData={projectData}
        dashboardSettings={dashboardSettings}
        updateDashboardProjectName={updateDashboardProjectName}
        onSave={handleSettingsSave}
        t={t}
        user={user}
        notify={notify}
        units={units}
      />
    </>
  );
};

ProjectNameCard.propTypes = {
  projectName: PropTypes.string,
  projectData: PropTypes.object,
  customerLogoUrl: PropTypes.string,
  dashboardSettings: PropTypes.object,
  t: PropTypes.func.isRequired,
  user: PropTypes.object,
  onUpdateSettings: PropTypes.func,
  units: PropTypes.string,
};

export default ProjectNameCard;
